<template>

    <v-dialog
          v-model="dialog.show"
          @keydown.esc="onCloseDialog"
          max-width="460"
        >
        <v-card flat tile>
          
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <h5 class="white--text font-weight-light">
                <template> {{ labels.changePassword }}</template>
              </h5>
            </v-toolbar-title>
            <v-spacer />
            <base-icon-close @close="onCloseDialog" :x_small="true"></base-icon-close>
          </v-toolbar>

          <v-card-text>
            <ApiForm
                ref="changePasswordForm"
                :formElements="elements"
                :extractErrorsFn="errors"
                :successFn="success"
                :errorFn="error"
                :submit="submit"
                :cancel="cancel"
                :endpoint="endpoint"
                @formReset="onFormResetEvent"
                method="put"
            />
          </v-card-text>

          <v-card-text v-show="successMessageShow">
            <p class="greenText">{{ labels.successMessage }}</p>
          </v-card-text>

          <v-card-text v-show="errorMessageShow">
            <p class="redText">{{ labels.errorMessage }}</p>
          </v-card-text>

        </v-card>

    </v-dialog>

</template>

<script>
import { mapGetters } from 'vuex'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'MapLocationCrudComponent',
  components: {
    BaseIconClose: () => import('@/components/BaseIconClose')
  },
  props: {
    dialog: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      labels: {
        changePassword: translate('Change password', 'baseLayout'),
        successMessage: translate('Success changed password', 'baseLayout'),
        errorMessage: translate('Server error, please try later', 'baseLayout')
      },
      elements: [
        {
          key: 'OldPassword',
          component: 'v-password-field',
          rules: 'required',
          label: '$oldPassword',
          type: 'password'
        },
        {
          key: 'NewPassword',
          component: 'v-password-field',
          rules: 'required',
          label: '$newPassword',
          type: 'password'
        },
        {
          key: 'ConfirmPassword',
          component: 'v-password-field',
          rules: 'required|confirmed:NewPassword',
          label: '$confirmPassword',
          type: 'password'
        }
      ],
      cancel: { text: '$cancel', color: 'secondary' },
      submit: { text: '$submit', color: 'primary' },
      successMessageShow: false,
      errorMessageShow: false
    }
  },
  mounted() {},
  computed: {
    ...mapGetters('user', ['jwtData']),
    endpoint() {
      return '/account/changePassword/' + this.jwtData.UserId
    }
  },
  methods: {
    onCloseDialog() {
      this.$refs.changePasswordForm.resetForm()
      this.onFormResetEvent()
    },
    onFormResetEvent() {
      this.$emit('close')
      this.errorMessageShow = false
      this.successMessageShow = false
    },
    errors(data) {
      return data.errors.map(el => {
        return {
          propertyName: el.PropertyName,
          error: el.Error
        }
      })
    },
    success(data) {
      this.errorMessageShow = false
      this.successMessageShow = true
      setTimeout(() => {
        this.onCloseDialog()
      }, 3000)
    },
    error(data) {
      this.errorMessageShow = true
    }
  }
}
</script>

<style scoped>
.col-md-12 {
  padding: 2px !important;
}
.greenText,
.redText {
  font-size: 16px;
}
.greenText {
  color: #16db00;
}
.redText {
  color: red;
}
</style>
